export default {
  "advertisers.title": "Associate your brand with Cameroonian tennis excellence",
  "advertisers.subtitle": "Tennis Club de Douala attracts the sports and business elite of Douala",
  "advertisers.audience": "Our Audience",
  "advertisers.audienceDesc": "A qualified and diverse audience to maximize your brand's impact",
  "advertisers.audience1": "Active members, families, and competitors",
  "advertisers.audience2": "Bonanjo and Douala business community",
  "advertisers.audience3": "International visitors (ITF tournaments)",
  "advertisers.audience4": "Central African sports community",
  "advertisers.offers": "Our Advertising Offers",
  "advertisers.offersDesc": "Tailored solutions to connect your brand with our premium community",
  "advertisers.offer1": "Tournament Title Sponsor",
  "advertisers.offer1Desc": "Logo on all media, event naming rights, international visibility",
  "advertisers.offer2": "Website Digital Banner",
  "advertisers.offer2Desc": "Premium placements on homepage and inner pages",
  "advertisers.offer3": "Mobile App Visibility",
  "advertisers.offer3Desc": "Ad placements in the court booking app",
  "advertisers.offer4": "Court Sponsorship",
  "advertisers.offer4Desc": "Court naming — e.g. Center Court — Your Brand",
  "advertisers.offer5": "Equipment Partnership",
  "advertisers.offer5Desc": "Visibility on club equipment and official attire",
  "advertisers.offer6": "Club Newsletter",
  "advertisers.offer6Desc": "Ad space in member communications",
  "advertisers.offer7": "Parasol Branding",
  "advertisers.offer7Desc": "Logo on club outdoor parasols — high visibility",
  "advertisers.offer8": "Net Branding",
  "advertisers.offer8Desc": "Logo on court nets — visible during all matches",
  "advertisers.offer9": "Locker Room Branding",
  "advertisers.offer9Desc": "Display in locker rooms — direct impact on members",
  "advertisers.offer10": "Reception Area Branding",
  "advertisers.offer10Desc": "Visibility in the lobby and reception areas — first point of contact",
  "advertisers.form.title": "Become a Partner",
  "advertisers.form.name": "Full Name",
  "advertisers.form.company": "Company",
  "advertisers.form.email": "Business Email",
  "advertisers.form.phone": "Phone",
  "advertisers.form.offer": "Offer of Interest",
  "advertisers.form.message": "Message",
  "advertisers.form.cta": "Submit My Request",
  "advertisers.contact": "Or contact us directly:",
  "advertisers.cta": "Become a Partner"
}